import script from "./OTPInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./OTPInput.vue?vue&type=script&setup=true&lang=ts"

import "./OTPInput.vue?vue&type=style&index=0&id=805483e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-805483e4"]])

export default __exports__